
import list from '@/mixins/list'
import { mapState } from 'vuex'

export default {
    mixins: [list],

    computed: {
        ...mapState({
            globalTexts: (state) => state.jsonloader.data['global.json'] || null,
        }),

        contentType() {
            return 'planning'
        },
        perPage() {
            return 8
        },

        isLoading() {
            return this.$fetchState && this.$fetchState.pending
        },
    },

    watch: {
        model: {
            handler() {
                this.userId = this.model.id
            },
            immediate: true,
        },
    },
}
